import { render, staticRenderFns } from "./AppointmentLink.vue?vue&type=template&id=4b2fc388&scoped=true"
import script from "./AppointmentLink.vue?vue&type=script&lang=js"
export * from "./AppointmentLink.vue?vue&type=script&lang=js"
import style0 from "./AppointmentLink.vue?vue&type=style&index=0&id=4b2fc388&prod&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b2fc388",
  null
  
)

export default component.exports